import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup
    .string()
    .min(2, "Mã địa bàn phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập mã địa bàn"),
  name: yup
    .string()
    .min(2, "Tên địa bàn phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập tên địa bàn"),
  notes: yup.string().nullable().optional(),
});
